import Url from 'urlinator/Url';
import { splitNameAndExtension } from './file';
const cache = {};
const successNoop = __meta => {};
const errorNoop = __err => {};
export default function preloadImage(src, callback = successNoop, errCallback = errorNoop) {
  if (cache[src]) {
    callback(cache[src]);
    return () => {};
  }
  const img = new window.Image();
  let cancelled = false;
  const loadHandler = () => {
    if (cancelled) {
      return;
    }
    const parsed = new Url(src);
    const segments = parsed.pathname.split('/');
    const {
      name,
      extension
    } = splitNameAndExtension({
      name: segments[segments.length - 1]
    });
    const meta = {
      url: src,
      width: img.width,
      height: img.height,
      name,
      extension
    };
    cache[src] = meta;
    callback(meta);
  };
  const errorHandler = error => {
    if (cancelled) {
      return;
    }
    cache[src] = false;
    errCallback({
      url: src,
      error
    });
  };
  img.src = src;
  img.addEventListener('load', loadHandler);
  img.addEventListener('error', errorHandler);
  return () => {
    if (cancelled) {
      return;
    }
    cancelled = true;
    img.removeEventListener('load', loadHandler);
    img.removeEventListener('error', errorHandler);
  };
}